import React from 'react';

interface props {
  label: string | JSX.Element;
  children: React.ReactNode;
}

export default function CTextFieldDisplay(props: props) {
  return (
    <div className={'flex flex-col'}>
      <div className={'text-xs font-black uppercase opacity-80'}>{props.label}</div>
      <div className={'text-base'}>{props.children === '' ? '-' : props.children}</div>
    </div>
  );
}
